import { type TimeZoneResult } from '@common/types/api';
import { type IanaId } from '@common/types/brandedTypes';

interface TimeZone {
  readonly id: string;
  readonly name: string;
  readonly offsetFromUtc: number;
  readonly ianaId: IanaId;
}

export const createTimeZoneFromResponse = (apiTimeZone: TimeZoneResult): TimeZone => ({
  id: apiTimeZone.id,
  name: apiTimeZone.description,
  offsetFromUtc: apiTimeZone.offsetFromUtc,
  ianaId: apiTimeZone.ianaId,
});

export default TimeZone;
